import { useAuth } from '@/lib/auth-context'
import { Home } from '@/pages/Home'
import { Welcome } from '@/pages/Welcome'

export function Landing() {
  const { user } = useAuth()

  if (user) {
    return <Home />
  }

  return <Welcome />
}
